var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-sheet",
    {
      staticClass: "pb-4 px-5 text-center transparent",
      attrs: { "max-width": "600" },
    },
    [
      _c("img", {
        staticClass: "mt-6 mb-3",
        attrs: {
          src: require("@/assets/appLogo-color--Onlight.svg"),
          width: "24",
        },
      }),
      _c("span", { staticClass: "d-block body-2 grey-700--text" }, [
        _vm._v(
          "Estás recibiendo este email porque eres cliente de " +
            _vm._s(_vm.account.name) +
            ", quien utiliza Factura X para sus procesos de emisión."
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }